import { render } from "./VideoEditorCmp.vue?vue&type=template&id=be9ff690"
import script from "./VideoEditorCmp.vue?vue&type=script&lang=js"
export * from "./VideoEditorCmp.vue?vue&type=script&lang=js"

import "./VideoEditorCmp.vue?vue&type=style&index=0&id=be9ff690&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__